import { DefinitionLevels, SettingValues } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import moment from 'moment';
import { useMemo } from 'react';

const useWorkingDaysUtils = ({ teamId = null } = {}) => {
  const { getTeamOrOrgSetting } = useSettingsService();

  const workingDaysSetting = getTeamOrOrgSetting({
    name: SettingValues.WORKING_DAYS,
    ...(teamId && {
      definitionLevel: DefinitionLevels.TEAM,
      teamId
    })
  });

  const workingDaysSet = useMemo(() => {
    const [start, end] = workingDaysSetting.split('-').map(Number);
    return new Set(
      Array.from({ length: end - start + 1 }, (_, i) => (start + i) % 7)
    );
  }, [workingDaysSetting]);

  const calculateWorkingDaysDiff = ({ startDate, endDate }) => {
    const start = moment(startDate).startOf('day');
    const end = moment(endDate).startOf('day');
    const today = moment().startOf('day');

    if (!start.isValid() || !end.isValid() || end.isBefore(start)) {
      return {};
    }

    let passedDays = 0;
    let leftDays = 0;
    let totalDays = 0;
    const current = start.clone();

    while (current.isSameOrBefore(end)) {
      const weekday = current.day() + 1; // 1 (Sunday) to 7 (Saturday)

      if (workingDaysSet.has(weekday)) {
        totalDays++;

        if (current.isBefore(today)) passedDays++;
        else if (current.isAfter(today)) leftDays++;
      }

      current.add(1, 'day');
    }

    return { passedDays, leftDays, totalDays };
  };

  return {
    workingDaysSetting,
    calculateWorkingDaysDiff
  };
};

export default useWorkingDaysUtils;
